import React from 'react';
import { Facebook, Instagram, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Logo and Tagline */}
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_phone-fix-quotes/artifacts/vsjgmfo7_NEXERA-02.png" 
            alt="NEXERA"
            className="w-auto h-20 mx-auto mb-4"
            style={{
              filter: 'brightness(0) invert(1)'
            }}
          />
          <p className="text-gray-400 text-sm">
            Fast. Quality. Reliable. The Next Era of Repair
          </p>
        </div>

        {/* Social Media Links */}
        <div className="flex justify-center gap-6 mb-8">
          <a 
            href="https://www.facebook.com/profile.php?id=61583189475460#" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ backgroundColor: 'rgba(0, 179, 179, 0.2)' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00B3B3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 179, 179, 0.2)'}
            aria-label="Facebook"
          >
            <Facebook className="w-5 h-5 text-white" />
          </a>

          <a 
            href="https://instagram.com/nexerarepair" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ backgroundColor: 'rgba(0, 179, 179, 0.2)' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00B3B3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 179, 179, 0.2)'}
            aria-label="Instagram"
          >
            <Instagram className="w-5 h-5 text-white" />
          </a>

          <a 
            href="https://tiktok.com/@nexerarepair" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ backgroundColor: 'rgba(0, 179, 179, 0.2)' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00B3B3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 179, 179, 0.2)'}
            aria-label="TikTok"
          >
            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
            </svg>
          </a>

          <a 
            href="https://twitter.com/nexerarepair" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ backgroundColor: 'rgba(0, 179, 179, 0.2)' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00B3B3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 179, 179, 0.2)'}
            aria-label="X (Twitter)"
          >
            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>

          <a 
            href="https://share.google/udiGsgTuj8s9oci0B" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
            style={{ backgroundColor: 'rgba(0, 179, 179, 0.2)' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#00B3B3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 179, 179, 0.2)'}
            aria-label="Google My Business"
          >
            <MapPin className="w-5 h-5 text-white" />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center pt-8 border-t border-gray-800">
          <p className="text-gray-500 text-sm">
            © {currentYear} Nexera Phone Repair. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;